import { createFileRoute } from '@tanstack/react-router';
import { CondicoesPage, lerBuscaCondicoes } from '@/components/condicoes-pagamento';

export const Route = createFileRoute('/_app/cadastros/condicoes')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaCondicoes(bruto),
  component: CondicoesRota,
});

function CondicoesRota() {
  return <CondicoesPage busca={Route.useSearch()} />;
}
